/** URL publique canonique — jamais exposer *.web.app / hébergeurs techniques au grand public. */
export const PUBLIC_SITE_URL = 'https://conakryenpoche.com';

const FIREBASE_HOSTING_HOSTS = new Set([
  'ckry-f7bd7.web.app',
  'ckry-f7bd7.firebaseapp.com'
]);

function isInternalOrNonPublicHostname(hostname = '') {
  const host = String(hostname).toLowerCase().replace(/^www\./, '');
  if (!host) return false;
  if (host === 'conakryenpoche.com') return false;
  if (FIREBASE_HOSTING_HOSTS.has(host)) return true;
  if (host.endsWith('.web.app') || host.endsWith('.firebaseapp.com')) return true;
  if (host.includes('infomaniak')) return true;
  if (host.endsWith('.hosting-agency.net') || host.endsWith('.myd.infomaniak.com')) return true;
  if (host === 'localhost' || host.endsWith('.local')) return true;
  return false;
}

export function isFirebaseHostingHostname(hostname = '') {
  return isInternalOrNonPublicHostname(hostname);
}

/** Origine à utiliser dans les liens / QR partagés avec le public. */
export function getPublicSiteOrigin() {
  return PUBLIC_SITE_URL;
}

/** Construit une URL absolue publique (chemin relatif ou absolu). */
export function publicSiteUrl(path = '/') {
  const base = PUBLIC_SITE_URL.replace(/\/$/, '');
  if (!path || path === '/') return `${base}/`;
  if (/^https?:\/\//i.test(path)) {
    try {
      const u = new URL(path);
      if (isInternalOrNonPublicHostname(u.hostname)) {
        return `${base}${u.pathname}${u.search}${u.hash}`;
      }
      // Toujours forcer le domaine public pour les chemins /invite/
      if (u.pathname.startsWith('/invite/')) {
        return `${base}${u.pathname}${u.search}${u.hash}`;
      }
      return path;
    } catch (_) {
      return path;
    }
  }
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
